export const WebcareerscityMap = {
    CREATE_WEB_CAREERS_CITY_START: 'CREATE_WEB_CAREERS_CITY_START',
    CREATE_WEB_CAREERS_CITY_SUCCESS: 'CREATE_WEB_CAREERS_CITY_SUCCESS',
    CREATE_WEB_CAREERS_CITY_ERROR: 'CREATE_WEB_CAREERS_CITY_ERROR',
    GET_ALL_WEB_CAREERS_CITY_START: 'GET_ALL_WEB_CAREERS_CITY_START',
    GET_ALL_WEB_CAREERS_CITY_SUCCESS: 'GET_ALL_WEB_CAREERS_CITY_SUCCESS',
    GET_ALL_WEB_CAREERS_CITY_ERROR: 'GET_ALL_WEB_CAREERS_CITY_ERROR',
    UPDATE_WEB_CAREERS_CITY_START: 'UPDATE_WEB_CAREERS_CITY_START',
    UPDATE_WEB_CAREERS_CITY_SUCCESS: 'UPDATE_WEB_CAREERS_CITY_SUCCESS',
    UPDATE_WEB_CAREERS_CITY_ERROR: 'UPDATE_WEB_CAREERS_CITY_ERROR',
    DELETE_WEB_CAREERS_CITY_START: 'DELETE_WEB_CAREERS_CITY_START',
    DELETE_WEB_CAREERS_CITY_SUCCESS: 'DELETE_WEB_CAREERS_CITY_SUCCESS',
    DELETE_WEB_CAREERS_CITY_ERROR: 'DELETE_WEB_CAREERS_CITY_ERROR',
    GET_WEB_CAREERS_CITY_DETAIL_START: 'GET_WEB_CAREERS_CITY_DETAIL_START',
    GET_WEB_CAREERS_CITY_DETAIL_SUCCESS: 'GET_WEB_CAREERS_CITY_DETAIL_SUCCESS',
    GET_WEB_CAREERS_CITY_DETAIL_ERROR: 'GET_WEB_CAREERS_CITY_DETAIL_ERROR',
    GET_WEB_CAREERS_CITY_LIST_START: 'GET_WEB_CAREERS_CITY_LIST_START',
    GET_WEB_CAREERS_CITY_LIST_SUCCESS: 'GET_WEB_CAREERS_CITY_LIST_SUCCESS',
    GET_WEB_CAREERS_CITY_LIST_ERROR: 'GET_WEB_CAREERS_CITY_LIST_ERROR',
    SEARCH_TEXT_CHANGE: "SEARCH_TEXT_CHANGE",
    REFRESH_WEB_CAREERS_CITY_LIST: "REFRESH_WEB_CAREERS_CITY_LIST",
    SET_WEB_CAREERS_CITY_BATCH_NUMBER: "SET_WEB_CAREERS_CITY_BATCH_NUMBER",
}

export const WebcareerscityActions = {
    getAllWebcareerscity: (data) => ({ type: WebcareerscityMap.GET_ALL_WEB_CAREERS_CITY_START, payload: data }),
    getAllWebcareerscitySuccess: (data) => ({ type: WebcareerscityMap.GET_ALL_WEB_CAREERS_CITY_SUCCESS, payload: data }),
    getAllWebcareerscityError: () => ({ type: WebcareerscityMap.GET_ALL_WEB_CAREERS_CITY_ERROR }),

    createWebcareerscityStart: () => ({ type: WebcareerscityMap.CREATE_WEB_CAREERS_CITY_START }),
    createWebcareerscitySuccess: (data) => ({ type: WebcareerscityMap.CREATE_WEB_CAREERS_CITY_SUCCESS, payload: data }),
    createWebcareerscityError: (errors) => ({ type: WebcareerscityMap.CREATE_WEB_CAREERS_CITY_ERROR, payload: { errors } }),

    updateWebcareerscityStart: () => ({ type: WebcareerscityMap.UPDATE_WEB_CAREERS_CITY_START }),
    updateWebcareerscitySuccess: (data) => ({ type: WebcareerscityMap.UPDATE_WEB_CAREERS_CITY_SUCCESS, payload: data }),
    updateWebcareerscityError: (errors) => ({ type: WebcareerscityMap.UPDATE_WEB_CAREERS_CITY_ERROR, payload: { errors } }),

    deleteWebcareerscityStart: () => ({ type: WebcareerscityMap.DELETE_WEB_CAREERS_CITY_START }),
    deleteWebcareerscitySuccess: (data) => ({ type: WebcareerscityMap.DELETE_WEB_CAREERS_CITY_SUCCESS, payload: data }),
    deleteWebcareerscityError: (errors) => ({ type: WebcareerscityMap.DELETE_WEB_CAREERS_CITY_ERROR, payload: { errors } }),

    getWebcareerscityDetail: (data) => ({ type: WebcareerscityMap.GET_WEB_CAREERS_CITY_DETAIL_START, payload: data }),
    getWebcareerscityDetailSuccess: (data) => ({ type: WebcareerscityMap.GET_WEB_CAREERS_CITY_DETAIL_SUCCESS, payload: data }),
    getWebcareerscityDetailError: () => ({ type: WebcareerscityMap.GET_WEB_CAREERS_CITY_DETAIL_ERROR }),

    getWebcareerscityListStart: (data) => ({ type: WebcareerscityMap.GET_WEB_CAREERS_CITY_LIST_START, payload: data }),
    getWebcareerscityListSuccess: (data) => ({ type: WebcareerscityMap.GET_WEB_CAREERS_CITY_LIST_SUCCESS, payload: data }),
    getWebcareerscityListError: () => ({ type: WebcareerscityMap.GET_WEB_CAREERS_CITY_LIST_ERROR }),

    searchTextChange: (data) => ({ type: WebcareerscityMap.SEARCH_TEXT_CHANGE, payload: data }),
    refreshWebcareerscityList: () => ({ type: WebcareerscityMap.REFRESH_WEB_CAREERS_CITY_LIST }),
    setWebcareerscityBatchNumber: (data) => ({ type: WebcareerscityMap.SET_WEB_CAREERS_CITY_BATCH_NUMBER, payload: data }),
}